module.exports = __webpack_public_path__ + "img/Kiko-Ani.5b44261b.gif";